module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAAwElEQVR4AWyRMQ4BURRFf6xBZQMShYhSYhWi0iipWIKSXqMTeiuwAWEFiIYFSGzAOfh/fjB5Z967991kXjKl8PtMsSKMRf0LH1lHGIv6DrdYNaEDdjXju/LwGGsBB5iAXa2PDCGGG6ghtGEJe3iAWt99CndZzOEOlmfMGKqg7z6FK5gXiFVm6MEO9N2n8Anz9Sm65a0GnfXPDvHmNWIEdchLrb/SjOErYgBb8If0P12t7z6dwS5seNXgBnnXxwrhCQAA//9ELsPDAAAABklEQVQDABCfI6EPTCcjAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/converted_4.png
// module id = QH5e
// module chunks = 1